import React from "react";
import { Spinner } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchCustomerDetails } from "../../Services/CustomerService";
import { fetchOrdersByCustomer } from "../../Services/OrderService";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { AddressPicker } from "../../Components/AddressPicker";

export const CustomerView = () => {
  const [customer, setCustomer] = React.useState(null);
  const [customerLoading, setCustomerLoading] = React.useState(false);
  const [orders, setOrders] = React.useState([]);
  const [ordersLoading, setOrdersLoading] = React.useState(false);
  const [selectedAddress, setSelectedAddress] = React.useState(null);
  const [showAddress, setShowAddress] = React.useState(false);

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    const customerId = params?.["id"];
    if (customerId) {
      dispatch({ type: "setCustomerId", payload: customerId });
      fetchCustomer(customerId);
    }
  }, []);

  React.useEffect(() => {
    if (customer) {
      setSelectedAddress(customer.addresses?.[0]);
      fetchOrders();
    }
  }, [customer]);
  const fetchCustomer = (id) => {
    setCustomerLoading(true);
    fetchCustomerDetails(id).then(
      (res) => {
        // console.log(res.data?.[0]);
        setCustomer(res.data?.[0]);
        setCustomerLoading(false);
      },
      (err) => {
        console.warn(err);
        toast.error("Something went wrong while fetching customer details.");
      }
    );
  };
  const fetchOrders = () => {
    setOrdersLoading(true);
    fetchOrdersByCustomer(customer.id).then(
      (res) => {
        setOrdersLoading(false);
        setOrders(res.data);
      },
      (err) => {
        console.warn(err);
        toast.error("Something went wrong while fetching customer's orders.");
      }
    );
  };

  return (
    <div className="container my-5" style={{ minHeight: "65vh" }}>
      {customerLoading ? (
        <div className="col-12 text-center ">
          <Spinner variant="primary" />
        </div>
      ) : Boolean(customer) ? (
        <>
          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h5 className="card-title fw-bold mb-0">
                Customer ID: {customer.id}
              </h5>
            </div>
          </div>

          <div className="card shadow-sm mb-3">
            <div className="card-body">
              <h6 className="mb-0">
                <b>Joined On:</b>{" "}
                <span className="text-muted">
                  {format(customer.created_at, "do MMM yyyy")}
                </span>
              </h6>
            </div>
          </div>

          <div className="row">
            <div className="col-md-8">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h6 className="fw-bold card-title mb-0">Details</h6>
                  <hr />
                  {/* <div className="d-flex justify-content-between mb-3">
                  <input
                    type="text"
                    className="form-control w-50"
                    placeholder="Search"
                  />
                  <button className="btn btn-outline-primary">Search</button>
                </div> */}

                  {ordersLoading ? (
                    <div className="col-12 text-center ">
                      <Spinner variant="primary" />
                    </div>
                  ) : orders.length !== 0 ? (
                    <table className="table">
                      <thead className="table-light">
                        <tr>
                          <th>SR. NO</th>
                          <th>ORDER ID</th>
                          <th>ORDER DATE</th>
                          <th>ORDER TOTAL</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.data.map((order, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>
                              <Link to={`/admin/orders/view/${order.id}`}>
                                {order.id}
                              </Link>
                            </td>
                            <td>{format(order.created_at, "do MMM yyyy")}</td>
                            <td>Rs {order.order_amount?.toLocaleString()}</td>
                            <td className="action-td">
                              <span
                                onClick={() => {
                                  navigate(`/admin/orders/view/${order.id}`);
                                }}
                              >
                                <i className="fa-regular fa-eye"></i>
                              </span>
                              <span
                                onClick={() => {
                                  if (
                                    ["delivered", "cancelled"].includes(
                                      order.order_status
                                    ) ||
                                    order.payment_status === "paid" ||
                                    order.order_process === "hub"
                                  )
                                    toast.error("This order cannot be edited.");
                                  else
                                    navigate(`/admin/orders/edit/${order.id}`);
                                }}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h6 className="fw-bold card-title mb-0">Details</h6>
                  <hr />
                  <div className="d-flex align-items-center">
                    <img
                      style={{
                        height: "52px",
                        width: "52px",
                        borderRadius: "50%",
                        marginRight: "20px",
                      }}
                      src={process.env.PUBLIC_URL +"/assets/images/usericon.png"}
                      alt=""
                    />
                    <div className="media-body">
                      <span style={{ color: "#444444", fontSize: "14px" }}>
                        {customer.f_name} {customer.l_name}
                      </span>
                      <br />
                      <span style={{ color: "#757575", fontSize: "14px" }}>
                        {" "}
                        {orders?.data?.length} Orders
                      </span>
                    </div>
                  </div>
                  <hr />
                  <ul className="list-unstyled" style={{ color: "#677788" }}>
                    <li>
                      <i className="me-2 fa-solid fa-envelope"></i>{" "}
                      {customer.email}
                    </li>
                    <li>
                      <i className="me-2 fa-solid fa-phone"></i>{" "}
                      {customer.phone}
                    </li>
                  </ul>
                  {/* <hr /> */}
                  <h6 className="fw-bold card-title mb-3">
                    Registered Address Details
                  </h6>
                  <div className="d-flex mb-3 cvalw">
                    {customer.addresses?.map((address) => (
                      <button
                        className={`btn btn-sm text-uppercase ${
                          address.id === selectedAddress?.id
                            ? "btn-dark"
                            : "btn-outline-dark"
                        } me-2`}
                        disabled={address.id === selectedAddress?.id}
                        onClick={() => {
                          if (address.id !== selectedAddress?.id) {
                            setSelectedAddress(address);
                          }
                        }}
                      >
                        {address.address_type}
                      </button>
                    ))}

                    {/* <button className="btn btn-outline-secondary">
                      OTHERS
                    </button> */}
                  </div>
                  {selectedAddress ? (
                    <table class="table table-striped mb-0">
                      <tbody>
                        <tr>
                          <td style={{ width: "140px" }}>Address Line 1</td>
                          <td>{selectedAddress?.address1}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "140px" }}>Address Line 2</td>
                          <td>{selectedAddress?.address2}</td>
                        </tr>
                      </tbody>
                    </table>
                  ) : null}
                  {/* <hr />
                  <button
                    className=" btn btn-dark text-primary w-100 btn-lg"
                    onClick={() => setShowAddress(true)}
                  >
                    Manage Addresses
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
      {showAddress ? (
        <AddressPicker
          show={showAddress}
          closeButton={true}
          onHide={() => setShowAddress(false)}
          title="Below are your addresses!"
          editOnSelect={true}
        />
      ) : null}
    </div>
  );
};
